import memoize from 'lodash/memoize'
import { configureChains, createConfig, createStorage } from 'wagmi'
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'
import { PUBLIC_NODES, VIEM_CHAINS } from '~/config/constants/chains'
import { connectorsForWallets } from '@rainbow-me/rainbowkit'
import { metaMaskWallet, walletConnectWallet } from '@rainbow-me/rainbowkit/wallets'
import { bloomWallet } from '~/utils/bloomWallet'

// get most configs chain nodes length
const mostNodesConfig = Object.values(PUBLIC_NODES).reduce((prev, cur) => {
  return cur.length > prev ? cur.length : prev
}, 0)

export const { publicClient, chains } = configureChains(
  VIEM_CHAINS,
  Array.from({ length: mostNodesConfig })
    .map((_, i) => i)
    .map((i) => {
      return jsonRpcProvider({
        rpc: (chain) => {
          // if (process.env.NODE_ENV === 'test' && chain.id === mainnet.id && i === 0) {
          //   return { http: 'https://eth.llamarpc.com' }
          // }
          return PUBLIC_NODES[chain.id]?.[i]
            ? {
              http: PUBLIC_NODES[chain.id][i],
            }
            : null
        },
      })
    }),
  {
    batch: {
      multicall: {
        batchSize: 1024 * 200,
        wait: 16,
      },
    },
    pollingInterval: 6_000,
  },
)

export const noopStorage = {
  getItem: (_key) => '',
  setItem: (_key, _value) => null,
  removeItem: (_key) => null,
}

const connectors = connectorsForWallets([
  {
    groupName: 'Recommended',
    wallets: [
      metaMaskWallet({ shimDisconnect: true, walletConnectVersion: '1', chains }),
      bloomWallet({ projectId: '9a3cdaf0cd0d95a961ad5192234b72c2', chains }),
      walletConnectWallet({ projectId: '9a3cdaf0cd0d95a961ad5192234b72c2', chains }),
    ],
  },
])


export const wagmiConfig = createConfig({
  storage: createStorage({
    storage: typeof window !== 'undefined' ? window.localStorage : noopStorage,
    key: 'wagmi_v1.1',
  }),
  autoConnect: true,
  publicClient,
  connectors,
})

export const CHAIN_IDS = chains.map((c) => c.id)

export const isChainSupported = memoize((chainId: number) => (CHAIN_IDS as number[]).includes(chainId))
export const isChainTestnet = memoize((chainId: number) => {
  const found = chains.find((c) => c.id === chainId)
  return found ? 'testnet' in found : false
})
